import { render, staticRenderFns } from "./webinar.vue?vue&type=template&id=56dd1bf5&"
import script from "./webinar.vue?vue&type=script&lang=js&"
export * from "./webinar.vue?vue&type=script&lang=js&"
import style0 from "./webinar.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "webinar.vue"
export default component.exports